<div class="cr-driver__root-container">
  <div class="cr-driver__root_content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    @if (overlayService.config) {
      <pc-status-overlay [small]="true" class="cr-driver_overlay_container"></pc-status-overlay>
    }
    <app-footer class="cr-driver_footer"></app-footer>
  </div>
</div>
